import React, { useEffect, useState } from 'react';
import Button from '../button';

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { connect } from 'react-redux';
import TextInputField from '../textInput';
import Select from '../select';
import Checkbox from '../checkbox';
import API from '../../api';
import { PlusSquare } from 'react-feather';
import Swal from 'sweetalert2';
import { ChromePicker } from 'react-color';
import { Modal } from 'antd';
import LoadingText from '../loadingText';
// STYLE
import './createProductMasterModal.styles.css';
import { APP_LOCALE, useLanguage } from '@languages/index';
import { useLocation } from 'react-router-dom';
import SeedingWithCommissionsPanel from 'pages/notification-panel/SeedingWithCommissionsPanel';
import { TYPES as SEEDING_WITH_COMMISSION_TYPE } from 'pages/campaigns/alert/seedingWithCommissionsAlert';
import { LOCALES } from 'constants/locales';
import Label from 'components/label';
import { isGlovv } from 'constants/domains/domains';
import SelectCategories from './components/selectCategories/selectCategories';
import useGetCategories from 'hooks/useGetCategories/useGetCategories';
import useGetBrand from 'hooks/useGetBrand/useGetBrand';

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

export const RENTAL_TYPE = {
  RENTAL: 'RENTAL',
  SEEDING: 'SEEDING',
};

const CreateProductMasterModal = (props: any) => {
  const location = useLocation();
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.products };
  const forceUpdate = useForceUpdate();

  const [styles, setStyles] = useState([]);

  const [isSetupClothes, setIsSetup] = useState(false);

  const [names, setNames] = useState<any>([{}]);
  const [prevNames, setPrevNames] = useState<any>([]);

  const [colors, setColors] = useState<any>([
    {
      colorValue: '#FF0000',
      sizes: [{}],
    },
  ]);
  const [prevColors, setPrevColors] = useState<any>([]);

  const [sizes, setSizes] = useState<any>([{}]);
  const [subItem, setSubItem] = useState('');
  const [atTag, setAtTag] = useState(props?.master?.atTag ?? '');

  const [fetchedSizes, setFetchedSizes] = useState<any>([]);
  const [selectedStyle, setSelectedStyle] = useState<any>();
  const [selectedMainCategory, setSelectedMainCategory] = useState<any>();
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>();

  const [seasons, setSeasons] = useState<any>({
    spring: false,
    summer: false,
    fall: false,
    winter: false,
  });

  const [sex, setSex] = useState<any>({
    female: props.brand.lastAvailableSex ? props.brand.lastAvailableSex.includes('1') : false,
    male: props.brand.lastAvailableSex ? props.brand.lastAvailableSex.includes('2') : false,
  });

  const masterImageInput = React.useRef(null);
  const [masterImages, setMasterImages] = useState<any>([]);
  const subImageInput = React.useRef(null);
  const [currentSubImageIndex, setCurrentSubImageIndex] = useState(0);
  const [isColorPickerVisible, setIsColorPickerVisible] = useState([]);

  const [deletedColors, setDeletedColors] = useState([]);
  const [deletedSizes, setDeletedSizes] = useState([]);

  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);

  const [isFetching, setIsFetching] = useState(true);

  const { data: brand } = useGetBrand();

  const { data: categories } = useGetCategories({
    params: {
      brandCategoryId: brand?.categoryId,
    },
    options: {
      enabled: !!brand?.categoryId,
    },
  });

  // 카테고리 조회 후 로직 처리
  useEffect(() => {
    // Product Master 정보가 있는 경우(ex: 제품정보 수정하기로 진입 시)
    if (props.master) {
      setSelectedMainCategory(categories?.find((category) => category.id == props.master.categoryId));
      setSelectedSubCategory({
        id: props.master.subCategoryId,
        name: props.master.subCategoryName,
      });
    }
  }, [categories]);

  useEffect(() => {
    fetchStyles();
    fetchSizes();
  }, []);

  useEffect(() => {
    if (colors) {
      let colorsCopy = [...colors];

      colorsCopy.forEach((color, colorIndex) => {
        color.index = colorIndex;
        color.sizes.forEach((size, sizeIndex) => {
          size.index = sizeIndex;
        });
      });

      if (JSON.stringify(colorsCopy) != JSON.stringify(prevColors)) {
        setColors(colorsCopy);
        setPrevColors(colorsCopy);
        forceUpdate();
      }
    }
  }, [colors]);

  useEffect(() => {
    if (names) {
      let namesCopy = [...names];

      namesCopy.forEach((name, index) => {
        name.index = index;
      });

      if (JSON.stringify(namesCopy) != JSON.stringify(prevNames)) {
        setNames(namesCopy);
        setPrevNames(namesCopy);
        forceUpdate();
      }
    }
  }, [names]);

  useEffect(() => {
    if (styles.length && fetchedSizes.length) {
      if (props.master) {
        setIsSetup(props.master.isSetup);

        setNames([
          {
            name: props.master.name,
            url: `${props.master.url}`,
            priceMarket: Number(props.master.priceMarket).toLocaleString(),
          },
        ]);

        let seasons = props.master.seasonFl ? props.master.seasonFl.split(',') : [false, false, false, false];

        setSeasons({
          spring: seasons[0] > 0 ? true : false,
          summer: seasons[1] > 0 ? true : false,
          fall: seasons[2] > 0 ? true : false,
          winter: seasons[3] > 0 ? true : false,
        });

        let availableSex = props.master.sex ? props.master.sex.split(',') : [false, false];

        setSex({
          female: availableSex[0] > 0 ? true : false,
          male: availableSex[1] > 0 ? true : false,
        });

        setSelectedStyle({
          id: props.master.styleId,
          name: props.master.styleName,
        });

        setSubItem(props.master.subItem ?? '');

        let colorsCopy: any = [...props.master.colors];

        colorsCopy = colorsCopy.map((color) => {
          let sizeCopy = [...color.sizes];
          sizeCopy = sizeCopy.map((size) => {
            return {
              ...size,
              name: size.sizeName,
              id: size.sizeId,
            };
          });

          return {
            ...color,
            colorName: color.name,
            colorValue: color.value,
            sizes: sizeCopy,
          };
        });

        setColors(colorsCopy);

        setMasterImages(props.master.images.filter((image) => image.imgOrder > 0).map((image) => image.imageUrl));

        setTimeout(() => {
          forceUpdate();
        }, 500);
      }

      setIsFetching(false);
    }
  }, [styles, fetchedSizes]);

  useEffect(() => {
    if (isSetupClothes) {
      setSelectedMainCategory(categories?.filter((category) => category.langKo == '셋업' && category.parentId == 0)[0]);
    }
  }, [isSetupClothes]);

  const fetchStyles = () => {
    API.Style.index({})
      .then((response) => {
        setStyles(response.data.styles);
      })
      .catch((error) => {
        props.showModal({
          text: languageTexts.create_master_text_1,
        });
      });
  };

  const fetchSizes = () => {
    API.Size.index({
      category_id: selectedMainCategory ? selectedMainCategory.id : null,
    })
      .then((response) => {
        const sizes = response.data.sizes.filter((size) => size.name !== languageTexts.create_master_text_3);

        setFetchedSizes(sizes);
      })
      .catch((error) => {
        props.showModal({
          text: languageTexts.create_master_text_4,
        });
      });
  };

  const handleSexClick = (target) => {
    let sexCopy = JSON.parse(JSON.stringify(sex));
    sexCopy[`${target}`] = !sexCopy[`${target}`];
    setSex(sexCopy);
  };

  const renderPageTitle = () => {
    return (
      <div className="container flex flex-col justify-center">
        <div className="py-[30px] px-[20px]">
          <span className="font-bold text-[22px]">
            {props.master ? languageTexts.create_master_text_5 : languageTexts.create_master_text_6}
          </span>
        </div>
      </div>
    );
  };

  const handleProductImage = (e, colorIndex) => {
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const image = e.target.files[0];

    const fileExtension = image.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      props.showModal({ text: languageTexts.create_master_text_43 });
      e.target.value = '';
      return;
    }

    API.Product.uploadImage({
      brandToken: props.auth.token,
      image: image,
    })
      .then((response: any) => {
        let imageUrl = response.data.url;
        let colorsCopy = [...colors];
        colorsCopy[colorIndex]['image'] = imageUrl;
        setColors(colorsCopy);
      })
      .catch((error: any) => {
        props.showModal(error.response.data.message);
      })
      .finally(() => {
        forceUpdate();
        e.target.value = '';
      });
  };

  const renderCreateForms = () => {
    const renderProductImages = (color, colorIndex) => {
      return color.image ? (
        <div
          className="flex justify-center items-center cursor-pointer my-3 relative"
          style={{
            width: '135px',
            height: '135px',
            border: '1px solid #E8E8E8',
          }}
          onClick={() => {}}
        >
          <img
            className="w-full h-full object-contain"
            src={`https://nmodelin20.s3.ap-northeast-2.amazonaws.com/product/${colors[colorIndex]['image']}`}
          />

          <div
            className="absolute bg-white border-grey-400 p-1"
            style={{ right: 0, top: 0 }}
            onClick={() => {
              let colorsCopy = [...colors];
              colorsCopy[colorIndex]['image'] = null;
              setColors(colorsCopy);
            }}
          >
            <img className="w-[22px] h-[22px]" src="/assets/icons/ic-close-black-squared.svg" />
          </div>
        </div>
      ) : null;
    };

    const handleSubImageInput = (index) => {
      subImageInput.current.click();
      setCurrentSubImageIndex(index);
    };

    const renderProductImageAddButton = (color, colorIndex) => {
      return color.image ? null : (
        <div
          className="flex justify-center items-center cursor-pointer my-3"
          style={{
            width: '135px',
            height: '135px',
            border: '1px solid #E8E8E8',
          }}
          onClick={() => {
            handleSubImageInput(colorIndex);
          }}
        >
          <PlusSquare />
        </div>
      );
    };

    const renderDetailImages = () => {
      return masterImages.map((image, imageIndex) => {
        return (
          <div
            key={`masterImage${image}`}
            className="flex justify-center items-center cursor-pointer relative"
            style={{
              width: '135px',
              height: '135px',
              border: '1px solid #E8E8E8',
            }}
            onClick={() => {}}
          >
            <img
              className="w-full h-full object-contain"
              src={`https://nmodelin20.s3.ap-northeast-2.amazonaws.com/product/${image}`}
            />

            <div
              className="absolute p-1"
              style={{ right: 0, top: 0 }}
              onClick={() => {
                if (masterImages.length <= 1) {
                  Swal.fire({
                    icon: 'error',
                    text: languageTexts.create_master_text_38,
                  });
                  return;
                }

                Swal.fire({
                  icon: 'info',
                  text: languageTexts.create_master_text_7,
                  showCancelButton: true,
                  confirmButtonText: languageTexts.delete,
                  cancelButtonText: languageTexts.cancel,
                }).then((result) => {
                  if (result.isConfirmed) {
                    let imagesCopy = masterImages.filter((item) => item != image);
                    setMasterImages(imagesCopy);

                    API.Product.deleteImage({
                      brandToken: props.auth.token,
                      productMasterId: props?.master?.id ?? null,
                      url: image,
                    })
                      .then((response): any => {
                        setTimeout(() => {
                          Swal.fire({
                            icon: 'info',
                            text: response.message,
                          });
                        }, 500);
                      })
                      .catch((error) => {
                        setTimeout(() => {
                          Swal.fire({
                            icon: 'error',
                            text: error.message,
                          });
                        }, 500);
                      });
                  }
                });
              }}
            >
              <img className="w-[22px] h-[22px]" src="/assets/icons/ic-close-black-squared.svg" />
            </div>
          </div>
        );
      });
    };

    const getImageSize = (file): { [key: string]: any } => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);

        img.onload = () => {
          resolve({ width: img.width, height: img.height });
          URL.revokeObjectURL(url); // Clean up the URL object
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = url;
      });
    };

    const handleProductDetailImage = async (e) => {
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

      const filesArray = Array.from(e.target.files).filter((file: any) => {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        return allowedExtensions.includes(fileExtension);
      });

      if (filesArray.length !== e.target.files.length) {
        Swal.fire({
          icon: 'error',
          text: languageTexts.create_master_text_43,
        });
        e.target.value = '';
        return;
      }

      e.target.value = '';

      for (let file of filesArray) {
        try {
          const size = await getImageSize(file);
          if (size.height > 20000) {
            Swal.fire({
              icon: 'error',
              text: languageTexts.create_master_text_44,
            });
            return;
          }
        } catch (error) {
          console.error('Error checking image size:', error);
        }
      }

      const uploadPromises = filesArray.map((image) => {
        return API.Product.uploadImage({
          brandToken: props.auth.token,
          image: image,
        })
          .then((response) => {
            return response.data.url;
          })
          .catch((error) => {
            props.showModal(error.response.data.message);
            return null;
          });
      });

      Promise.all(uploadPromises)
        .then((uploadedImageUrls) => {
          const validImageUrls = uploadedImageUrls.filter((url) => url !== null);
          setMasterImages([...masterImages, ...validImageUrls]);
        })
        .finally(() => {
          forceUpdate();
        });
    };

    const renderDetailImageAddButton = () => {
      return (
        <div
          className="flex justify-center items-center cursor-pointer"
          style={{
            width: '135px',
            height: '135px',
            border: '1px solid #E8E8E8',
          }}
          onClick={() => {
            masterImageInput.current.click();
          }}
        >
          <div className="">
            <PlusSquare />
          </div>
          <input
            type="file"
            multiple={true}
            ref={masterImageInput}
            onChange={(e) => handleProductDetailImage(e)}
            style={{ display: 'none' }}
          />
        </div>
      );
    };

    const handleColor = (colorIndex) => {
      if (isColorPickerVisible.includes(colorIndex) == false) {
        let arr = isColorPickerVisible;
        setIsColorPickerVisible([...arr, colorIndex]);
      } else {
        let arr = isColorPickerVisible.filter((item) => item !== colorIndex);

        setIsColorPickerVisible(arr);
      }
    };

    const renderSubForms = () => {
      return (
        <div className="flex flex-col mx-[20px] gap-3 text-sm md:text-base">
          {colors.map((color, colorIndex) => (
            <div key={`color${colorIndex}`} className="flex flex-col mt-[40px]">
              <div className="flex flex-row">
                <div className="flex justify-between items-center w-full mb-3">
                  <span className="text-[18px] text-black font-bold">
                    {isSetupClothes
                      ? languageTexts.create_master_text_55
                      : languageTexts._create_master_text_49(colors.length > 1 ? colorIndex : undefined)}
                  </span>

                  {!isSetupClothes && colorIndex + 1 > 1 ? (
                    <div className="cursor-pointer">
                      <Button
                        className="p-0"
                        onClick={() => {
                          setDeletedColors([...deletedColors, color]);
                          colors.splice(colorIndex, 1);
                          setColors(colors);
                        }}
                        icon={{
                          icon: <img className="w-[22px] h-[22px]" src="/assets/icons/ic-close-black-squared.svg" />,
                          position: 'centerLeft',
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <table className="flex flex-col w-full border-t border-black">
                <tbody className="flex flex-col">
                  {isSetupClothes ? null : (
                    <>
                      <tr className="flex flex-row border-b border-[#E8E8E8]">
                        <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                          <div className="flex flex-row">
                            <span className="text-[15px]">{languageTexts.color_value}</span>
                            <span className="text-[#FF0099] ml-[2px]">*</span>
                          </div>
                        </td>
                        <td className="w-[calc(100%-150px)] py-[10px] pl-[10px]">
                          <div className="w-[75px] h-[75px] flex justify-center items-center">
                            <div className="flex w-full h-full cursor-pointer">
                              <div className="relative w-full">
                                <TextInputField
                                  onChangeText={(value) => {
                                    let colorsCopy = [...colors];
                                    colorsCopy[colorIndex]['colorValue'] = value;
                                    setColors(colorsCopy);
                                  }}
                                  value={color.colorValue ?? ''}
                                  bordered={true}
                                  placeholder={'#'}
                                  disabled
                                  className="text-sm md:text-base"
                                />

                                <div
                                  className="absolute flex items-center justify-center"
                                  style={{
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0,
                                  }}
                                >
                                  {isColorPickerVisible.includes(colorIndex) ? (
                                    <div className="flex flex-col absolute left-0 z-10">
                                      <ChromePicker
                                        disableAlpha
                                        color={color.colorValue ?? ''}
                                        onChange={(color) => {
                                          let colorsCopy = [...colors];
                                          colorsCopy[colorIndex]['colorValue'] = color.hex;
                                          setColors(colorsCopy);
                                        }}
                                      />
                                      <div className="flex flex-col bg-white drop-shadow-lg">
                                        <Button
                                          bordered={true}
                                          text={languageTexts.confirm}
                                          onClick={() => {
                                            let arr = isColorPickerVisible.filter((item) => item !== colorIndex);
                                            setIsColorPickerVisible(arr);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : null}

                                  <Button
                                    className={'w-full h-full'}
                                    buttonColor={
                                      color.colorValue?.startsWith('#') ? color.colorValue : `#${color.colorValue}`
                                    }
                                    onClick={() => {
                                      handleColor(colorIndex);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr className="border-b border-[#E8E8E8] flex flex-row items-center ">
                        <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                          <div className="flex flex-row">
                            <span className="text-[15px]">{languageTexts.color_name}</span>
                            <span className="text-[#FF0099] ml-[2px]">*</span>
                          </div>
                        </td>
                        <td className="w-[calc(100%-150px)] pl-[10px]" colSpan={2}>
                          <div className="flex w-full">
                            <TextInputField
                              className="w-full"
                              inputClassName="px-[10px] py-[6px] text-[15px]"
                              value={color.colorName ?? ''}
                              onChangeText={(value) => {
                                let colorsCopy = [...colors];
                                colorsCopy[colorIndex]['colorName'] = value;
                                setColors(colorsCopy);
                              }}
                              bordered={true}
                              placeholder={languageTexts.input}
                            />
                          </div>
                        </td>
                      </tr>
                    </>
                  )}

                  <tr className="border-b border-[#E8E8E8]">
                    <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                      <div className="flex flex-row">
                        <span className="text-[15px]">
                          {!isSetupClothes
                            ? languageTexts.create_master_text_11
                            : languageTexts.create_master_text_11_setup}
                        </span>
                        <span className="text-[#FF0099] ml-[2px]">*</span>
                      </div>
                    </td>
                    <td className="w-[calc(100%-150px)] pl-[10px]">
                      <div className="text-[12px] text-[#999999]">{languageTexts.create_master_text_50}</div>
                      <div className="flex flex-row gap-3">
                        {renderProductImages(color, colorIndex)}
                        {renderProductImageAddButton(color, colorIndex)}
                      </div>
                    </td>
                  </tr>

                  <tr className="flex flex-row ">
                    <td className="w-full p-0">
                      {color.sizes.map((size, sizeIndex) => {
                        const qtyOptions: any = [
                          // { name: languageTexts.create_master_text_13 }
                        ];
                        for (let i = 0; i < 30; i++) {
                          qtyOptions.push({
                            name: i + 1,
                          });
                        }

                        let filteredSize = [];
                        if (selectedMainCategory) {
                          filteredSize = [
                            ...(selectedSubCategory && selectedSubCategory.hasSpecificSizes
                              ? selectedMainCategory.sizesAvailable.filter((sizeToCompare) => {
                                  if (
                                    (sizeToCompare.subCategoryId == null &&
                                      props.rentalType == RENTAL_TYPE.RENTAL &&
                                      sizeToCompare.isUseInRental == true) ||
                                    (props.rentalType == RENTAL_TYPE.SEEDING && sizeToCompare.isUseInSeeding == true)
                                  ) {
                                    return true;
                                  }

                                  if (
                                    sizeToCompare.subCategoryId &&
                                    sizeToCompare.subCategoryId != selectedSubCategory.id
                                  ) {
                                    return false;
                                  }

                                  if (props.rentalType == RENTAL_TYPE.RENTAL && sizeToCompare.isUseInRental == false) {
                                    return false;
                                  }

                                  if (
                                    props.rentalType == RENTAL_TYPE.SEEDING &&
                                    sizeToCompare.isUseInSeeding == false
                                  ) {
                                    return false;
                                  }

                                  return true;
                                })
                              : selectedMainCategory.sizesAvailable.filter((sizeToCompare) => {
                                  if (props.rentalType == RENTAL_TYPE.RENTAL && sizeToCompare.isUseInRental == false) {
                                    return false;
                                  }

                                  if (
                                    props.rentalType == RENTAL_TYPE.SEEDING &&
                                    sizeToCompare.isUseInSeeding == false
                                  ) {
                                    return false;
                                  }

                                  return true;
                                })),
                          ];
                        }

                        return (
                          <table key={sizeIndex} className="w-full border-b border-[#E8E8E8]">
                            <tbody>
                              {isSetupClothes ? (
                                <tr>
                                  <td className="w-[150px] px-[10px] py-[20px] text-[15px] bg-[#F4F4F4]">
                                    <div className="flex flex-row">
                                      <span>{languageTexts.create_master_text_56}</span>
                                      <span className="text-[#FF0099] ml-[2px]">*</span>
                                    </div>
                                  </td>
                                  <td className="pl-[10px] border-b border-[#E8E8E8]" colSpan={2}>
                                    <Select
                                      selectClassName={'show-scrollbar text-[15px] py-[9px] px-[10px]'}
                                      bordered
                                      options={qtyOptions}
                                      placeholder={languageTexts.select}
                                      value={size.qty ?? ''}
                                      onChange={(value) => {
                                        const selected = qtyOptions.filter((qty) => {
                                          return qty.name == value;
                                        })[0];

                                        let sizesCopy = [...colors[colorIndex]['sizes']];
                                        sizesCopy[sizeIndex]['qty'] = selected.name;
                                        setSizes(sizesCopy);

                                        let colorsCopy = [...colors];
                                        colorsCopy[colorIndex]['sizes'] = sizesCopy;
                                        setColors(colorsCopy);
                                      }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  {brand?.isCategoryFashion ? (
                                    <>
                                      <tr>
                                        <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px] text-[15px]">
                                          <div className="flex flex-row justify-between">
                                            <div className="flex flex-row">
                                              <span>{`${languageTexts.size} ${
                                                colors[colorIndex]['sizes'].length > 1 ? sizeIndex + 1 : ''
                                              }`}</span>
                                              <span className="text-[#FF0099] ml-[2px]">*</span>
                                            </div>

                                            {sizeIndex + 1 > 1 ? (
                                              <div
                                                className="cursor-pointer p-0"
                                                onClick={() => {
                                                  let sizesCopy = [...colors[colorIndex]['sizes']];
                                                  sizesCopy = sizesCopy.filter((item) => item.index != size.index);

                                                  let colorsCopy = [...colors];
                                                  colorsCopy[colorIndex]['sizes'] = sizesCopy;
                                                  setDeletedSizes([...deletedSizes, size]);
                                                  setColors(colorsCopy);
                                                }}
                                              >
                                                <img
                                                  className="w-[16px] h-[16px]"
                                                  src="/assets/icons/ic-close-black-squared.svg"
                                                />
                                              </div>
                                            ) : null}
                                          </div>
                                        </td>
                                        <td className="pl-[10px] border-b border-[#E8E8E8]" colSpan={2}>
                                          <Select
                                            selectClassName={'show-scrollbar text-[15px] py-[9px] px-[10px]'}
                                            bordered
                                            options={
                                              selectedMainCategory
                                                ? [
                                                    // {
                                                    //   name: languageTexts.create_master_text_39,
                                                    // },
                                                    ...filteredSize,
                                                  ]
                                                : [
                                                    // {
                                                    //   name: languageTexts.create_master_text_14,
                                                    // },
                                                  ]
                                            }
                                            value={size.name ?? ''}
                                            placeholder={
                                              selectedMainCategory
                                                ? languageTexts.select
                                                : languageTexts.create_master_text_14
                                            }
                                            onChange={(value) => {
                                              const selected = fetchedSizes.filter((size) => {
                                                return size.name == value;
                                              })[0];

                                              let sizesCopy = [...colors[colorIndex]['sizes']];
                                              sizesCopy[sizeIndex]['id'] = selected.id;
                                              sizesCopy[sizeIndex]['name'] = selected.name;
                                              setSizes(sizesCopy);

                                              let colorsCopy = [...colors];
                                              colorsCopy[colorIndex]['sizes'] = sizesCopy;
                                              setColors(colorsCopy);
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </>
                                  ) : null}
                                  <tr>
                                    <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px] text-[15px]"></td>
                                    <td className="w-[150px] px-[10px] py-[20px] text-[15px]">
                                      <div className="flex flex-row">
                                        <span>
                                          {brand?.isCategoryFashion
                                            ? languageTexts.create_master_text_56_full
                                            : languageTexts.create_master_text_56}
                                        </span>
                                        <span className="text-[#FF0099] ml-[2px]">*</span>
                                      </div>
                                    </td>
                                    <td className="pl-[10px] border-b border-[#E8E8E8]">
                                      <Select
                                        selectClassName={'show-scrollbar text-[15px] py-[9px] px-[10px]'}
                                        bordered
                                        options={qtyOptions}
                                        placeholder={languageTexts.select}
                                        value={size.qty ?? ''}
                                        onChange={(value) => {
                                          const selected = qtyOptions.filter((qty) => {
                                            return qty.name == value;
                                          })[0];

                                          let sizesCopy = [...colors[colorIndex]['sizes']];
                                          sizesCopy[sizeIndex]['qty'] = selected.name;
                                          setSizes(sizesCopy);

                                          let colorsCopy = [...colors];
                                          colorsCopy[colorIndex]['sizes'] = sizesCopy;
                                          setColors(colorsCopy);
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        );
                      })}
                    </td>
                  </tr>

                  {brand?.isCategoryFashion ? (
                    <>
                      {isSetupClothes ? null : (
                        <tr className="flex flex-row py-[10px] border-b border-[#E8E8E8]">
                          <td className="w-full">
                            <Button
                              bordered
                              text={languageTexts.create_master_text_20}
                              onClick={() => {
                                let colorsCopy = [...colors];
                                let sizesCopy = [...colorsCopy[colorIndex]['sizes']];
                                sizesCopy.push({});
                                colorsCopy[colorIndex]['sizes'] = sizesCopy;
                                setColors(colorsCopy);
                              }}
                            />
                          </td>
                        </tr>
                      )}
                    </>
                  ) : null}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      );
    };

    const renderInfoPanel = () => {
      const isCampaign = location.pathname.includes('campaign');

      if (brand?.isWholesale) return null;
      if (brand?.isCategoryFashion == false) return null;

      return (
        <div className="flex flex-row">
          <div
            className="w-full flex flex-row justify-center py-[15px] px-[15px]"
            style={{
              backgroundColor: `rgba(250, 112, 53, 0.1)`,
            }}
          >
            <Label
              labelColor="#FF0099"
              textColor="white"
              text={languageTexts.create_master_text_47}
              className="px-[8px] py-[3px] mr-[10px]"
            />
            <span className="flex flex-col font-bold text-[15px] tracking-tighter text-[#E9804f]">
              {isCampaign ? languageTexts._create_master_text_41() : languageTexts._create_master_text_42()}
            </span>
          </div>
        </div>
      );
    };

    const renderMasterForms = () => {
      return (
        <div className="flex flex-col mx-[20px] gap-3 text-sm md:text-base">
          {renderInfoPanel()}

          {brand?.isCategoryFashion ? (
            <div className="flex flex-row items-center gap-3 my-[40px]">
              <Checkbox
                text={languageTexts.create_master_text_21}
                checked={isSetupClothes}
                onClick={() => {
                  const targetStatus = !isSetupClothes;
                  setIsSetup(targetStatus);
                  setNames(targetStatus ? [names[0], {}] : [names[0]]);
                  setColors([{ ...colors[0], sizes: [colors[0].sizes[0]] }]);
                }}
              />
            </div>
          ) : null}

          <div className="flex flex-row">
            <span className="text-[18px] text-black font-bold">{languageTexts.create_master_text_48}</span>
          </div>

          <table className="w-full">
            <tbody className="border-t border-black">
              {names.map((name, index) => (
                <React.Fragment key={index}>
                  <tr className="">
                    <td className="w-[150px] bg-[#F4F4F4]">
                      <div className="px-[10px] py-[20px]">
                        <span className="text-[15px]">
                          <div className="flex flex-row justify-between">
                            <div className="flex flex-row">
                              <span>
                                {isSetupClothes
                                  ? languageTexts._create_master_text_22(index + 1)
                                  : languageTexts.product_name}
                              </span>
                              <span className="text-[#FF0099] ml-[2px]">*</span>
                            </div>

                            {index + 1 > 2 ? (
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  let namesCopy = [...names];
                                  namesCopy = namesCopy.filter((item) => item.index != name.index);
                                  setNames(namesCopy);
                                }}
                              >
                                <img className="w-[16px] h-[16px]" src="/assets/icons/ic-close-black-squared.svg" />
                              </div>
                            ) : null}
                          </div>
                        </span>
                      </div>
                    </td>
                    <td className="w-[calc(100%-150px)] pl-[10px] py-[12px] bg-white border-b border-[#E8E8E8]">
                      <p className="mb-[10px] text-[12px] text-[#FA0000]">{languageTexts.create_master_text_57}</p>
                      <TextInputField
                        className="w-full"
                        value={names[index]?.name ?? ''}
                        onChangeText={(value) => {
                          let namesCopy = [...names];
                          namesCopy[index]['name'] = value;
                          setNames(namesCopy);
                        }}
                        inputClassName="px-[10px] py-[6px] text-[15px]"
                        bordered={true}
                        placeholder={languageTexts.input}
                      />
                    </td>
                  </tr>

                  {!brand?.isWholesale && (
                    <tr className="">
                      <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]"></td>
                      <td className="w-[calc(100%-150px)] border-b border-[#E8E8E8]">
                        <div className="flex items-center py-[10px]">
                          <div className="flex flex-row">
                            <div className="w-[150px] px-[10px] text-[15px]">
                              <div className="flex flex-row">
                                <span>URL</span>
                                <span className="text-[#FF0099] ml-[2px]">*</span>
                              </div>
                            </div>
                          </div>
                          <div className="w-[calc(100%-150px)]">
                            <TextInputField
                              className="w-full"
                              inputClassName="px-[10px] py-[6px] text-[15px]"
                              value={names[index]?.url ?? ''}
                              onChangeText={(value) => {
                                let namesCopy = [...names];
                                namesCopy[index]['url'] = value;
                                setNames(namesCopy);
                              }}
                              bordered={true}
                              placeholder={languageTexts.input}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr className={isSetupClothes ? '' : 'border-b border-[#E8E8E8]'}>
                    <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]"></td>
                    <td className="w-[calc(100%-150px)] border-b border-[#E8E8E8]">
                      <div className="flex items-center py-[10px]">
                        <div className="w-[150px] px-[10px] text-[15px] whitespace-nowrap">
                          <span className="text-[15px]">
                            {brand?.isWholesale ? (
                              languageTexts.create_master_text_40
                            ) : (
                              <>
                                {`${languageTexts.create_master_text_24} `}
                                {brand?.isCategoryFashion
                                  ? `${
                                      APP_LOCALE === LOCALES.JA
                                        ? languageTexts.create_master_text_25_jp
                                        : languageTexts.create_master_text_25
                                    }`
                                  : null}
                              </>
                            )}
                            <span className="text-[#FF0099] ml-[2px]">*</span>
                          </span>
                        </div>
                        <div className="w-[calc(100%-150px)]">
                          <TextInputField
                            className="w-full"
                            inputClassName="px-[10px] py-[6px] text-[15px]"
                            value={names[index]?.priceMarket ? names[index]?.priceMarket.toLocaleString() : ''}
                            defaultValue={names[index]?.priceMarket ? names[index]?.priceMarket.toLocaleString() : ''}
                            onChangeText={(value) => {
                              if (!/^\d*$/.test(value.replace(/,/g, ''))) {
                                return;
                              }

                              let namesCopy = [...names];
                              namesCopy[index]['priceMarket'] = Math.floor(Number(value.replace(/,/g, '')));
                              setNames(namesCopy);
                            }}
                            bordered={true}
                            placeholder={languageTexts.input}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>

                  {/* 뷰티 카테고리 (온보딩 끝나고 다시 배포하기 위한 임시 주석) */}
                  {brand?.isCategoryBeauty && (
                    <SelectCategories
                      isSetupClothes={isSetupClothes}
                      selectedMainCategory={selectedMainCategory}
                      setSelectedMainCategory={setSelectedMainCategory}
                      selectedSubCategory={selectedSubCategory}
                      setSelectedSubCategory={setSelectedSubCategory}
                    />
                  )}

                  {isSetupClothes && !props.master ? (
                    <>
                      <tr className="">
                        <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]"></td>
                        <td className="w-[calc(100%-150px)] border-b border-[#E8E8E8]">
                          <div className="flex items-center py-[10px]">
                            <div className="flex flex-row">
                              <div className="w-[150px] px-[10px] text-[15px]">
                                <div className="flex flex-row">
                                  <span>{languageTexts.create_master_text_52}</span>
                                  <span>({languageTexts._text_max_length_short(10)})</span>
                                  <span className="text-[#FF0099] ml-[2px]">*</span>
                                </div>
                              </div>
                            </div>
                            <div className="w-[calc(100%-150px)]">
                              <TextInputField
                                className="w-full"
                                inputClassName="px-[10px] py-[6px] text-[15px]"
                                value={names[index]?.colorName ?? ''}
                                onChangeText={(value) => {
                                  let namesCopy = [...names];
                                  namesCopy[index]['colorName'] = value;
                                  setNames(namesCopy);
                                }}
                                bordered={true}
                                placeholder={languageTexts.input}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr className="border-b border-[#E8E8E8]">
                        <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]"></td>
                        <td className="w-[calc(100%-150px)]">
                          <div className="flex items-center py-[10px]">
                            <div className="flex flex-row">
                              <div className="w-[150px] px-[10px] text-[15px]">
                                <div className="flex flex-row">
                                  <span>{languageTexts.create_master_text_53}</span>
                                  <span>({languageTexts._text_max_length_short(10)})</span>
                                  <span className="text-[#FF0099] ml-[2px]">*</span>
                                </div>
                              </div>
                            </div>
                            <div className="w-[calc(100%-150px)]">
                              <TextInputField
                                className="w-full"
                                inputClassName="px-[10px] py-[6px] text-[15px]"
                                value={names[index]?.sizeName ?? ''}
                                onChangeText={(value) => {
                                  let namesCopy = [...names];
                                  namesCopy[index]['sizeName'] = value;
                                  setNames(namesCopy);
                                }}
                                bordered={true}
                                placeholder={`${languageTexts.input} ${languageTexts.create_master_text_54}`}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : null}
                </React.Fragment>
              ))}
              {isSetupClothes ? (
                <tr className="border-b border-[#E8E8E8]">
                  <td className="w-[calc(100%-150px)] py-[10px]" colSpan={2}>
                    <Button
                      bordered
                      text={languageTexts.create_master_text_26}
                      onClick={() => {
                        let namesCopy = [...names];
                        namesCopy.push({});
                        setNames(namesCopy);
                      }}
                    />
                  </td>
                </tr>
              ) : null}
              {brand?.isCategoryFashion ? (
                <>
                  <tr className="border-b border-[#E8E8E8]">
                    <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                      <div className="flex flex-row">
                        <span className="text-[15px]">{languageTexts.gender}</span>
                        <span className="text-[#FF0099] ml-[2px]">*</span>
                      </div>
                    </td>
                    <td className="w-[calc(100%-150px)] pl-[10px]">
                      <div className="grid grid-cols-4 md:grid-cols-6">
                        <div className="w-[60px]">
                          <Checkbox
                            text={languageTexts.female}
                            checked={sex.female}
                            onClick={() => handleSexClick('female')}
                            onTextPress={() => handleSexClick('female')}
                          />
                        </div>
                        <div className="w-[60px]">
                          <Checkbox
                            text={languageTexts.male}
                            checked={sex.male}
                            onClick={() => handleSexClick('male')}
                            onTextPress={() => handleSexClick('male')}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b border-[#E8E8E8]">
                    <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                      <div className="flex flex-row">
                        <span className="text-[15px]">{languageTexts.season}</span>
                        <span className="text-[#FF0099] ml-[2px]">*</span>
                      </div>
                    </td>
                    <td className="w-[calc(100%-150px)] pl-[10px]">
                      <div className="grid grid-cols-4 md:grid-cols-6">
                        {Object.entries({
                          spring: languageTexts.spring,
                          summer: languageTexts.summer,
                          fall: languageTexts.fall,
                          winter: languageTexts.winter,
                        }).map(([key, label]) => (
                          <div key={key} className="w-[60px]">
                            <Checkbox
                              text={label}
                              checked={seasons[key]}
                              onClick={() => {
                                let seasonsCopy = { ...seasons };
                                seasonsCopy[key] = !seasonsCopy[key];
                                setSeasons(seasonsCopy);
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b border-[#E8E8E8]">
                    <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                      <div className="flex flex-row">
                        <span className="text-[15px]">{languageTexts.style}</span>
                        <span className="text-[#FF0099] ml-[2px]">*</span>
                      </div>
                    </td>
                    <td className="w-[calc(100%-150px)] pl-[10px]">
                      <Select
                        selectClassName="text-[15px] py-[9px] px-[10px] placeholder:text-gray-400"
                        // options={[{ name: languageTexts.create_master_text_27 }, ...styles]}
                        options={styles}
                        onChange={(value) => {
                          const selected = styles.filter((category) => category.name === value);
                          setSelectedStyle(selected[0]);
                        }}
                        value={selectedStyle?.name ?? ''}
                        bordered={true}
                        placeholder={languageTexts.select}
                      />
                    </td>
                  </tr>

                  {/* 패션 카테고리 */}
                  {!isSetupClothes && (
                    <SelectCategories
                      isSetupClothes={isSetupClothes}
                      selectedMainCategory={selectedMainCategory}
                      setSelectedMainCategory={setSelectedMainCategory}
                      selectedSubCategory={selectedSubCategory}
                      setSelectedSubCategory={setSelectedSubCategory}
                    />
                  )}

                  {props.master || !isSetupClothes ? (
                    <tr className="border-b border-[#E8E8E8]">
                      <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                        <span className="text-[15px]">{`${languageTexts.create_master_text_31} (${languageTexts.select})`}</span>
                      </td>
                      <td className="w-[calc(100%-150px)]">
                        <TextInputField
                          className="w-full pl-[10px]"
                          inputClassName="px-[10px] py-[6px] text-[15px]"
                          value={subItem ?? ''}
                          onChangeText={(value) => {
                            setSubItem(value);
                          }}
                          bordered={true}
                          placeholder={languageTexts.create_master_text_37}
                        />
                      </td>
                    </tr>
                  ) : null}

                  {/* // 차란, 차란 (릴스) */}
                  {[1617, 1745, 1526, 1984].includes(brand?.id) ? (
                    <tr className="border-b border-[#E8E8E8]">
                      <td className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                        <span className="text-[15px]">{`${languageTexts.create_master_text_45}`}</span>
                      </td>
                      <td className="w-[calc(100%-150px)]">
                        <TextInputField
                          className="w-full pl-[10px]"
                          inputClassName="px-[10px] py-[6px] text-[15px]"
                          value={atTag ?? ''}
                          onChangeText={(value) => {
                            setAtTag(value);
                          }}
                          bordered={true}
                          placeholder={`@${languageTexts.oneulook_en}`}
                        />
                      </td>
                    </tr>
                  ) : null}
                </>
              ) : null}
            </tbody>
          </table>
        </div>
      );
    };

    const createOrUpdateProduct = () => {
      function refineAtTag(atTag: string) {
        const tags = atTag
          .split(/[\s,]+/)
          .map((tag) => (tag.startsWith('@') ? tag : `@${tag}`))
          .filter((tag) => tag.length > 1);
        return tags.length > 0 ? tags.join(' ') : null;
      }

      const params = {
        brandToken: props.auth.token,
        brandId: brand?.id,
        rentalType: props.rentalType ? props.rentalType : RENTAL_TYPE.RENTAL,
        temporaryKey: props.temporaryKey?.current || props.temporaryKey || null,
        isSetupClothes: isSetupClothes,
        names: names.map((name: any) => {
          return {
            ...name,
            priceMarket: parseFloat(`${name.priceMarket}`.toString().replace(/,/g, '')),
          };
        }),
        atTag: refineAtTag(atTag),
        seasons,
        colors,
        sizes,
        subItem,
        categoryId: selectedSubCategory?.id || null,
        parentCategoryId: selectedMainCategory?.id || null,
        styleId: selectedStyle ? selectedStyle?.id : null,
        masterImages: masterImages,
        deletedColors,
        deletedSizes,
        sex: sex,
      };

      if (props.master) {
        API.Product.update({
          id: props.master.id,
          ...params,
        })
          .then((response) => {
            props.closeModal();
            setTimeout(() => {
              props.showModal({
                text: response.data.message,
              });
            }, 400);
            props.onSuccess ? props.onSuccess(response.data) : null;
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: 'error',
              text: error.message,
            });
          });
      } else {
        API.Product.store(params)
          .then((response) => {
            props.closeModal();
            // setTimeout(() => {
            //   props.showModal({
            //     text: response.data.message,
            //   });
            // }, 400);
            props.onSuccess ? props.onSuccess(response.data) : null;
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: 'error',
              text: error.message,
            });
          });
      }
    };

    const acceptTermsAndSubmitProducts = () => {
      const rentalType = props.rentalType ? props.rentalType : RENTAL_TYPE.RENTAL;

      if (!brand?.hasExperiencedProductCreate && rentalType == RENTAL_TYPE.RENTAL) {
        setIsTermsModalVisible(true);
        return false;
      }

      createOrUpdateProduct();
    };

    const TermsModal = (props: any) => {
      return (
        <Modal
          className="squared-antd-modal"
          centered={true}
          open={props.isTermsModalVisible}
          footer={null}
          closable={false}
          zIndex={1086}
          width={400}
        >
          <div className="flex flex-col justify-center align-center p-8 bg-white">
            <div className="content flex flex-col">
              <div className="font-bold text-[22px] text-black">{languageTexts.create_master_text_32}</div>
              <div className="flex flex-col items-start py-4">
                <span className="prose prose-md whitespace-pre-wrap leading-5 text-black">
                  {languageTexts._create_master_text_33()}
                </span>
              </div>

              <div className="flex flex-row justify-between">
                <Button
                  className={'w-full py-3 flex justify-center text-center text-base'}
                  textColor={'BLACK'}
                  buttonColor={'WHITE'}
                  text={languageTexts.cancel}
                  onClick={() => {
                    setIsTermsModalVisible(false);
                  }}
                />

                <Button
                  className={'w-full py-3 flex justify-center text-center text-base'}
                  textColor={'WHITE'}
                  buttonColor={'BLACK'}
                  text={languageTexts.agreement}
                  onClick={() => {
                    setIsTermsModalVisible(false);
                    createOrUpdateProduct();
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      );
    };

    return (
      <div className="relative flex flex-col">
        {isFetching && (
          <div
            className="absolute top-0 w-full h-full flex justify-center items-start z-[1]"
            style={{ backgroundColor: 'rgb(255 255 255/ 0.75)' }}
          >
            <LoadingText
              text={'Loading'}
              render={(text) => (
                <div className="mt-64 p-2 w-[180px] rounded-full text-center text-3xl font-bold text-[#333] select-none">
                  {text}
                </div>
              )}
            />
          </div>
        )}

        {renderMasterForms()}
        {renderSubForms()}

        {isSetupClothes ? null : (
          <div className="flex flex-row mb-3 mx-[20px] pt-[40px]">
            <Button
              bordered
              borderColor={'black'}
              text={languageTexts.create_master_text_34}
              onClick={() => {
                let colorsCopy = [...colors];
                colorsCopy.push({
                  colorValue: '#FF0000',
                  sizes: [{}],
                  images: [],
                });
                setColors(colorsCopy);
                setTimeout(() => {
                  forceUpdate();
                }, 200);
              }}
            />
          </div>
        )}

        <div className="flex flex-col mb-3 mx-5 pt-[40px]">
          <div className="flex flex-row py-[10px]">
            <span className="font-bold text-[18px] text-black">{languageTexts.create_master_text_35}</span>
          </div>
          <div className="flex flex-row border-t border-black">
            <div className="flex flex-row w-full border-b border-[#E8E8E8]">
              <div className="w-[150px] bg-[#F4F4F4] px-[10px] py-[20px]">
                <span className="text-[15px] text-black">{languageTexts.create_master_text_51}</span>
                <span className="text-[#FF0099] ml-[2px]">*</span>
              </div>
              <div className="flex flex-col">
                <div className="flex flex-col gap-[10px] p-[10px]">
                  <div className="flex flex-row">
                    <span className="text-[12px] text-[#999999]">
                      {languageTexts._create_master_text_36({
                        isVisibleSizeMessage: !brand?.isCategoryBeauty,
                      })}
                    </span>
                  </div>

                  {renderDetailImages()}
                  {renderDetailImageAddButton()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col mb-3 mx-5">
          <Button
            borderColor={'black'}
            buttonColor={'black'}
            textColor={'WHITE'}
            text={languageTexts.done}
            onClick={() => {
              acceptTermsAndSubmitProducts();
            }}
          />
        </div>

        <TermsModal isTermsModalVisible={isTermsModalVisible} />
      </div>
    );
  };

  return (
    <>
      <div className="flex flex-col max-h-[80dvh] overflow-scroll">
        <div className="modal-window bg-white mb-10">
          <div className="modal-header">{renderPageTitle()}</div>
          <div className="modal-body">{renderCreateForms()}</div>
          <input
            type="file"
            ref={subImageInput}
            onChange={(e) => handleProductImage(e, currentSubImageIndex)}
            style={{ display: 'none' }}
          />
          {isGlovv() == false ? (
            <RenderModals
              {...props}
              selectedMainCategory={selectedMainCategory}
              selectedSubCategory={selectedSubCategory}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

const RenderModals = (props: any) => {
  const isCampaign = props.rentalType == RENTAL_TYPE.SEEDING;

  const isTshirts =
    isCampaign &&
    props.selectedMainCategory &&
    props.selectedMainCategory.nameKo == '상의' &&
    props.selectedSubCategory &&
    props.selectedSubCategory.nameKo == '티셔츠';
  const isUnderwear = isCampaign && props.selectedMainCategory && props.selectedMainCategory.nameKo == '언더웨어';

  return (
    <>
      <SeedingWithCommissionsPanel
        isPanelVisible={false}
        type={SEEDING_WITH_COMMISSION_TYPE.T_SHIRTS}
        showAlert={isTshirts}
      />
      <SeedingWithCommissionsPanel
        isPanelVisible={false}
        type={SEEDING_WITH_COMMISSION_TYPE.UNDERWAER}
        showAlert={isUnderwear}
      />
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(CreateProductMasterModal);
